/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_500_Meta_PageInputs */

const ja_error_500_meta_page = /** @type {(inputs: Error_500_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`error500`)
};

const en_error_500_meta_page = /** @type {(inputs: Error_500_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`error500`)
};

/**
* | output |
* | --- |
* | "error500" |
*
* @param {Error_500_Meta_PageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const error_500_meta_page = /** @type {((inputs?: Error_500_Meta_PageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_500_Meta_PageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_error_500_meta_page(inputs)
	return en_error_500_meta_page(inputs)
});